// import { createStore, combineReducers, applyMiddleware } from 'redux';
// import { persistStore, persistReducer, createMigrate } from 'redux-persist';
// import { composeWithDevTools } from 'redux-devtools-extension';
// import thunk from 'redux-thunk';
// import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
// import getTime from 'date-fns/getTime';

// import rootReducer from './rootReducer';

// const reducers = combineReducers({
//   root: rootReducer,
// });

// const version = 8;

// const migrations = {
//   [version]: state => {
//     console.log('Migration Running!', state, {});
//     return {};
//   },
// };

// const persistConfig = {
//   key: 'root',
//   storage,
//   stateReconciler: hardSet,
//   whitelist: ['app', 'auth', 'quiz'],
//   timeout: 100,
//   debug: true,
//   version: version,
//   //migrate: createMigrate(migrations, { debug: true }),
// };

// const persistedReducer = persistReducer(persistConfig, reducers);

// export default preloadedState => {
//   console.log(preloadedState);

//   const store = createStore(
//     persistedReducer,
//     preloadedState, // initial state
//     composeWithDevTools(applyMiddleware(thunk))
//   );
//   const persistor = persistStore(store);

//   return { store, persistor };
// };

import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';

import rootReducer from './rootReducer';

const reducers = combineReducers({
  root: rootReducer,
});

const version = 9;

const migrations = {
  9: state => {
    return {};
  },
  8: state => {
    return {};
  },
  7: state => {
    return {};
  },
  6: state => {
    return {};
  },
  5: state => {
    return {};
  },
  4: state => {
    return {};
  },
  3: state => {
    return {};
  },
  2: state => {
    return {};
  },
  1: state => {
    return {};
  },
  0: state => {
    return {};
  },
};

const persistConfig = {
  key: 'root',
  storage,
  version,
  migrations,
};
const persistedReducer = persistReducer(persistConfig, reducers);

export default (preloadedState = {}) => {
  const store = createStore(
    persistedReducer,
    preloadedState, // initial state
    applyMiddleware(thunk)
  );
  const persistor = persistStore(store);
  return { store, persistor };
};

// import { createStore, combineReducers, applyMiddleware } from 'redux';
// import { persistStore, persistReducer } from 'redux-persist';
// import thunk from 'redux-thunk';
// import storage from 'redux-persist/lib/storage';

// import rootReducer from './rootReducer';

// const reducers = combineReducers({
//   root: rootReducer,
// });

// const persistConfig = {
//   key: 'root',
//   storage,
// };
// const persistedReducer = persistReducer(persistConfig, reducers);

// export default (preloadedState = {}) => {
//   const store = createStore(
//     persistedReducer,
//     preloadedState, // initial state
//     applyMiddleware(thunk)
//   );
//   const persistor = persistStore(store);
//   return { store, persistor };
// };
